import CollectionTypes from '../flux/reports/CollectionTypes';

const {
  COLLECTION_TYPE_SEASONAL,
  COLLECTION_TYPE_TIMELESS,
  COLLECTION_TYPE_PRODUCT_FOCUS
} = CollectionTypes;

export default function collectionTypeToParentType(collectionType) {
  const map = {
    [COLLECTION_TYPE_SEASONAL]: 'collections',
    [COLLECTION_TYPE_TIMELESS]: 'categories',
    [COLLECTION_TYPE_PRODUCT_FOCUS]: 'productFocuses'
  };

  return map[collectionType];
}
